// extracted by mini-css-extract-plugin
export default {"pagination__body":"TBody_pagination__body__aWxaj","tableSettings":"TBody_tableSettings__WeRbP"};